import { getTransform } from 'mlmi-library/utils/animation'

const autoplayState = new WeakMap()
const REVIEWS_BASE_SPEED = 8000
const REELS_BASE_SPEED = 8000

function scrollPause(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params || !swiper.autoplay) return
  const prev = autoplayState.get(swiper) || {}
  if (prev.status === 'paused') return

  const wrapper = swiper.wrapperEl
  if (!wrapper) return

  const targetValues = getTransform(wrapper) + ''
  const targetX = parseFloat(targetValues.split(',')[0]) || 0
  const computedTransform = getComputedStyle(wrapper).transform + ''
  const currentX = Math.round(parseFloat(computedTransform.split(',')[4]) || 0)

  clearTimeout(prev.resumeTimer)
  swiper.autoplay.stop()
  swiper.params.speed = 100

  wrapper.style.transitionDuration = '0ms'
  swiper.setTranslate(currentX)
  swiper.updateActiveIndex()

  autoplayState.set(swiper, {
    status: 'paused',
    delta: currentX - targetX,
    target: targetX,
    baseSpeed: prev.baseSpeed || REVIEWS_BASE_SPEED,
  })
}

function scrollPlay(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params || !swiper.autoplay) return
  const state = autoplayState.get(swiper)
  if (!state || state.status !== 'paused') return

  const wrapper = swiper.wrapperEl
  const firstSlide = swiper.slides && swiper.slides[0]
  if (!wrapper || !firstSlide) return

  const baseSpeed = state.baseSpeed || REVIEWS_BASE_SPEED
  const totalWidth = firstSlide.offsetWidth + (swiper.params.spaceBetween || 0)
  const deltaDuration = Math.max(50, Math.round(baseSpeed * state.delta / totalWidth))

  swiper.setTransition(deltaDuration)
  swiper.setTranslate(state.target)

  const resumeTimer = setTimeout(function() {
    // Swiper may have been destroyed/re-inited (resize, breakpoint) while pending
    if (!swiper || swiper.destroyed || !swiper.params || !swiper.autoplay) return
    swiper.params.speed = baseSpeed
    swiper.update()
    swiper.autoplay.start()
    autoplayState.set(swiper, { status: 'playing', baseSpeed: baseSpeed })
  }, deltaDuration)

  autoplayState.set(swiper, {
    status: 'resuming',
    resumeTimer: resumeTimer,
    baseSpeed: baseSpeed,
  })
}

function scrollReset(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params || !swiper.autoplay) return
  const state = autoplayState.get(swiper) || {}
  const baseSpeed = state.baseSpeed || REVIEWS_BASE_SPEED
  clearTimeout(state.resumeTimer)
  swiper.params.speed = baseSpeed
  swiper.update()
  swiper.autoplay.start()
  autoplayState.set(swiper, { status: 'playing', baseSpeed: baseSpeed })
}

// Shared carousel configurations
export const carouselConfigs = [
  {
    classSelector: 'carousel--forfaits',
    swiperOptions: {
      simulateTouch: true,
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          centeredSlides: true,
          initialSlide: 1,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 2.333,
          centeredSlides: false,
          spaceBetween: 20,
          initialSlide: 0,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
          initialSlide: 0,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--content',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 1.25,
        },
        768: {
          slidesPerView: 2.25,
        },
        1280: {
          slidesPerView: 4.5,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--woocommerce-product',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 1.25,
        },
        768: {
          slidesPerView: $('body').hasClass('woocommerce-cart') ? 2.35 : 2,
          spaceBetween: 12,
        },
        960: {
          slidesPerView: $('body').hasClass('woocommerce-cart') ? 2.35 : 3,
          spaceBetween: 16,
        },
        1280: {
          slidesPerView: $('body').hasClass('woocommerce-cart') ? 2.35 : 4,
          spaceBetween: 20,
        },
        1600: {
          slidesPerView: $('body').hasClass('woocommerce-cart') ? 2.35 : 5,
          spaceBetween: 20,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--woocommerce-related',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: $('body').hasClass('woocommerce-cart') ? 2.25 : 2.1,
          spaceBetween: 12,
        },
        1280: {
          slidesPerView: $('body').hasClass('woocommerce-cart') ? 2.5 : 4.5,
          spaceBetween: 20,
        },
        1600: {
          slidesPerView: $('body').hasClass('woocommerce-cart') ? 2.5 : 5,
          spaceBetween: 20,
        },
      },
    },
    carouselOptions: {
      forceInit: true,
      onInit: function(carousel) {
        const $carousel = $(carousel).parent()
        const $carouselTitle = $carousel.siblings('.carousel__title')
        if ($carouselTitle.length) {
          let hoverTimer = null
          const addHoverClass = function() {
            if (hoverTimer) {
              clearTimeout(hoverTimer)
              hoverTimer = null
            }
            $carouselTitle.addClass('carousel__title--hover')
          }
          const removeHoverClass = function() {
            hoverTimer = setTimeout(function() {
              $carouselTitle.removeClass('carousel__title--hover')
              hoverTimer = null
            }, 50)
          }
          $carousel.on('mouseenter', addHoverClass)
          $carousel.on('mouseleave', removeHoverClass)
          $carouselTitle.on('mouseenter', addHoverClass)
          $carouselTitle.on('mouseleave', removeHoverClass)
        }
      },
    },
  },
  {
    classSelector: 'carousel--style--blog-post',
    swiperOptions: {
      speed: 500,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 18,
        },
        768: {
          spaceBetween: 25,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--single-product',
    swiperOptions: {
      speed: 500,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 18,
        },
        768: {
          spaceBetween: 25,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--hero',
    swiperOptions: {
      speed: 1000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    },
  },
  {
    classSelector: 'carousel--style--reels',
    swiperOptions: {
      speed: 8000,
      loop: true,
      allowTouchMove: false,
      loopAdditionalSlides: 4,
      spaceBetween: 20,
      freeMode: {
        enabled: true,
        sticky: false,
      },
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 2.25,
          spaceBetween: 12,
        },
        576: {
          slidesPerView: 3.25,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 4.25,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 5.25,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 6.25,
          spaceBetween: 20,
        },
        1600: {
          slidesPerView: 7,
          spaceBetween: 20,
        },
      },
    },
    carouselOptions: {
      forceInit: true,
      onInit: function(carousel) {
        const $carousel = $(carousel)
        const $container = $carousel.closest('.carousel--reels')
        const swiper = $carousel.data('swiper') || ($carousel[0] && $carousel[0].swiper)

        if (!swiper || !$container.length) return

        // Title is a sibling of .carousel--reels, not a child
        var $title = $container.siblings('.carousel__title')
        if (!$title.length) $title = $container.closest('.col').find('.carousel__title')

        if (!$title.length) return

        $title.addClass('carousel__title--reels')

        // Relocate the canonical carousel toolbar (rendered by the use_arrows builder
        // option) into the title — no custom nav markup, reuses the site-wide button CSS
        var $toolbar = $container.find('.carousel__toolbar')
        if ($toolbar.length) $title.append($toolbar)

        // Disable Swiper native navigation: reels uses custom continuous-scroll snap logic
        if (swiper.navigation && swiper.navigation.destroy) swiper.navigation.destroy()

        var $prev = $title.find('.swiper-button-prev')
        var $next = $title.find('.swiper-button-next')

        function updateNav() {
          if (!swiper.params.loop) {
            $prev.toggleClass('swiper-button-disabled', swiper.isBeginning)
            $next.toggleClass('swiper-button-disabled', swiper.isEnd)
          }
        }

        updateNav()
        swiper.on('slideChange', updateNav)
        swiper.on('reachBeginning', updateNav)
        swiper.on('reachEnd', updateNav)

        var manualMode = false
        autoplayState.set(swiper, { status: 'playing', baseSpeed: REELS_BASE_SPEED })

        // Hover carousel: freeze in place, resume on leave. Namespaced + off-first so a
        // re-init (resize/breakpoint) never leaves stale handlers pointing at a dead swiper.
        $container.off('mouseenter.reels mouseleave.reels')
        $container.on('mouseenter.reels', function() { if (!manualMode) scrollPause(swiper) })
        $container.on('mouseleave.reels', function() { if (!manualMode) scrollPlay(swiper) })

        // Click arrow: snap to nearest slide, then navigate
        function handleArrowClick(direction) {
          if (!manualMode) {
            manualMode = true
            var state = autoplayState.get(swiper) || {}
            clearTimeout(state.resumeTimer)
            swiper.autoplay.stop()
            swiper.params.freeMode.enabled = false
            $container.addClass('carousel--reels--manual')
          }
          // Snap to nearest slide first, then navigate
          var currentX = parseFloat((getComputedStyle(swiper.wrapperEl).transform + '').split(',')[4]) || 0
          swiper.setTranslate(currentX)
          swiper.params.speed = 0
          swiper.slideToClosest(0)
          // Navigate after snap
          setTimeout(function() {
            swiper.params.speed = 500
            if (direction === 'prev') swiper.slidePrev(500)
            else swiper.slideNext(500)
          }, 50)
        }

        $prev.off('click').on('click', function() { handleArrowClick('prev') })
        $next.off('click').on('click', function() { handleArrowClick('next') })
      },
    },
  },
  {
    classSelector: 'carousel--style--reviews',
    swiperOptions: {
      loop: true,
      loopAdditionalSlides: 4,
      speed: REVIEWS_BASE_SPEED,
      allowTouchMove: true,
      threshold: 50,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.15,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 2.25,
          spaceBetween: 16,
        },
        1280: {
          slidesPerView: 2.9,
          spaceBetween: 20,
        },
      },
      on: {
        afterInit: function(swiper) {
          autoplayState.set(swiper, { status: 'playing', baseSpeed: REVIEWS_BASE_SPEED })
          const $carousel = $(swiper.el).closest('.carousel--style--reviews')
          $carousel.on('mouseenter', function() { scrollPause(swiper) })
          $carousel.on('mouseleave', function() { scrollPlay(swiper) })
        },
        touchEnd: function(swiper) {
          scrollReset(swiper)
        },
      },
    },
  },
]
